<template>
  <div>
    <CardInfo v-if="cardInfo.cardMode == 'card'"/>
    <CardNoShow v-if="cardInfo.cardMode == 'cardNoShow'" />
  </div>
</template>
<script>
import {wx_initCard} from "@/api/api.js"
import CardInfo from './card/cardInfo'
import CardNoShow from './card/cardNoShow'
export default {
  components: {
			CardInfo,
      CardNoShow
	},
  data() {
    return {
      cardInfo:{}
    };
  },
  computed: {},
  methods: {
    initCard(){
      let iccid = this.$route.query.iccid
      wx_initCard({iccid}).then(res=>{
        this.cardInfo = res.data.data
      })
    }
  },
  created() {
    this.initCard()
  },
  mounted(){
    
  }
};

</script>
<style scoped lang="less">
  
</style>

